const stats = [
    { value: "500+", label: "Enfants accompagnés" },
    { value: "6-20", label: "Ans, notre cible" },
    { value: "3", label: "Piliers efficaces" },
];

export default function Stats() {
    return (
        <section data-testid="stats-section" className="bg-ink-50/40">
            <div className="container-wide pb-24 sm:pb-32">
                <div className="rounded-[2rem] bg-gradient-to-br from-brand-500 to-brand-600 px-8 sm:px-14 py-12 sm:py-16 grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-6 text-white">
                    {stats.map((s, i) => (
                        <div
                            key={s.label}
                            data-testid={`stat-${i}`}
                            className="text-center sm:border-r sm:last:border-r-0 sm:border-white/20"
                        >
                            <p className="font-display font-bold text-5xl sm:text-6xl tracking-tight">
                                {s.value}
                            </p>
                            <p className="mt-3 text-brand-50 text-sm sm:text-base">{s.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
